/**
 * Shopify UTM & Click ID Attribution Tracker
 *
 * Generated for: pracas
 * Store: green-thumb-depot.shopify.com
 * Generated: 2026-03-04
 *
 * Installation: Add this script to your theme.liquid file before the closing </body> tag
 */

(function () {
  'use strict';

  // ============================================================================
  // CONFIGURATION - CUSTOMIZE THESE PARAMETERS
  // ============================================================================

  /**
   * FIRST TOUCH PARAMETERS
   * Captured on the user's FIRST visit and stored permanently (90 days)
   */
  var FIRST_TOUCH_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid'
  ];

  /**
   * LAST TOUCH PARAMETERS
   * Captured on EVERY visit and updated with latest values
   */
  var LAST_TOUCH_PARAMS = [

  ];

  // ============================================================================
  // ADVANCED SETTINGS
  // ============================================================================

  var CONFIG = {
    cookieExpiry: 90,
    cookieDomain: window.location.hostname,
    firstTouchPrefix: 'ft_',
    lastTouchPrefix: 'lt_',
    debug: false  // Set to true to see console logs during testing
  };

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================

  function getUrlParameter(name) {
    var regex = new RegExp('[?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    var domain = CONFIG.cookieDomain ? '; domain=' + CONFIG.cookieDomain : '';
    document.cookie = name + '=' + encodeURIComponent(value) + expires + domain + '; path=/; SameSite=Lax';

    if (CONFIG.debug) {
      console.log('Cookie set:', name, '=', value);
    }
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getGA4ClientId() {
    var gaCookie = getCookie('_ga');
    if (!gaCookie) return null;

    var parts = gaCookie.split('.');
    if (parts.length >= 4) {
      return parts[2] + '.' + parts[3];
    }
    return gaCookie;
  }

  function getTimestamp() {
    return Math.floor(Date.now() / 1000);
  }

  function isNewSession() {
    var lastVisit = getCookie('_last_visit');
    var now = getTimestamp();

    if (!lastVisit) return true;

    var timeSinceLastVisit = now - parseInt(lastVisit, 10);
    return timeSinceLastVisit > 1800; // 30 minutes
  }

  function updateLastVisit() {
    setCookie('_last_visit', getTimestamp(), 1);
  }

  // ============================================================================
  // ATTRIBUTION CAPTURE
  // ============================================================================

  function captureAttributionData() {
    var isNew = isNewSession();
    var lastTouchParams = {};
    var firstTouchParams = {};
    var hasLastTouchData = false;
    var hasFirstTouchData = false;

    // Capture LAST TOUCH parameters
    LAST_TOUCH_PARAMS.forEach(function(param) {
      var value = getUrlParameter(param);
      if (value) {
        hasLastTouchData = true;
        lastTouchParams[param] = value;
      }
    });

    // Capture FIRST TOUCH parameters
    FIRST_TOUCH_PARAMS.forEach(function(param) {
      var value = getUrlParameter(param);
      if (value) {
        hasFirstTouchData = true;
        firstTouchParams[param] = value;
      }
    });

    if (!hasLastTouchData && !hasFirstTouchData) {
      updateLastVisit();
      return;
    }

    var timestamp = getTimestamp();
    if (hasLastTouchData) {
      lastTouchParams['timestamp'] = timestamp;
    }
    if (hasFirstTouchData) {
      firstTouchParams['timestamp'] = timestamp;
    }

    // Store LAST TOUCH
    if (hasLastTouchData) {
      Object.keys(lastTouchParams).forEach(function(key) {
        setCookie(CONFIG.lastTouchPrefix + key, lastTouchParams[key], CONFIG.cookieExpiry);
      });
      if (CONFIG.debug) {
        console.log('Last touch captured:', lastTouchParams);
      }
    }

    // Store FIRST TOUCH (only if none exists)
    if (hasFirstTouchData) {
      var hasExistingFirstTouch = false;
      for (var i = 0; i < FIRST_TOUCH_PARAMS.length; i++) {
        if (getCookie(CONFIG.firstTouchPrefix + FIRST_TOUCH_PARAMS[i])) {
          hasExistingFirstTouch = true;
          break;
        }
      }

      if (!hasExistingFirstTouch) {
        Object.keys(firstTouchParams).forEach(function(key) {
          setCookie(CONFIG.firstTouchPrefix + key, firstTouchParams[key], CONFIG.cookieExpiry);
        });
        if (CONFIG.debug) {
          console.log('First touch captured:', firstTouchParams);
        }
      }
    }

    updateLastVisit();
  }

  // ============================================================================
  // SHOPIFY CART INTEGRATION
  // ============================================================================

  function collectAttributionForCart() {
    var attributes = {};

    // Collect FIRST TOUCH
    FIRST_TOUCH_PARAMS.forEach(function(param) {
      var value = getCookie(CONFIG.firstTouchPrefix + param);
      if (value) {
        attributes['first_touch_' + param] = value;
      }
    });

    var ftTimestamp = getCookie(CONFIG.firstTouchPrefix + 'timestamp');
    if (ftTimestamp) {
      attributes['first_touch_timestamp'] = ftTimestamp;
    }

    // Collect LAST TOUCH
    LAST_TOUCH_PARAMS.forEach(function(param) {
      var value = getCookie(CONFIG.lastTouchPrefix + param);
      if (value) {
        attributes['last_touch_' + param] = value;
      }
    });

    var ltTimestamp = getCookie(CONFIG.lastTouchPrefix + 'timestamp');
    if (ltTimestamp) {
      attributes['last_touch_timestamp'] = ltTimestamp;
    }

    // Add GA4 Client ID
    var ga4Id = getGA4ClientId();
    if (ga4Id) {
      attributes['ga4_client_id'] = ga4Id;
    }

    return attributes;
  }

  function updateShopifyCart() {
    var attributesToSet = collectAttributionForCart();

    if (Object.keys(attributesToSet).length === 0) {
      if (CONFIG.debug) {
        console.log('No attribution data to update');
      }
      return;
    }

    if (CONFIG.debug) {
      console.log('Updating Shopify cart with:', attributesToSet);
    }

    fetch('/cart.js')
      .then(function(res) {
        if (!res.ok) throw new Error('Failed to fetch cart');
        return res.json();
      })
      .then(function(cart) {
        var currentAttributes = cart.attributes || {};
        var needsUpdate = false;

        for (var key in attributesToSet) {
          if (attributesToSet.hasOwnProperty(key) &&
              currentAttributes[key] !== attributesToSet[key]) {
            needsUpdate = true;
            break;
          }
        }

        if (!needsUpdate) {
          if (CONFIG.debug) {
            console.log('Cart attributes already up to date');
          }
          return;
        }

        var updatedAttributes = Object.assign({}, currentAttributes, attributesToSet);

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: updatedAttributes
          })
        });
      })
      .then(function(res) {
        if (res && res.ok) {
          if (CONFIG.debug) {
            console.log('Cart attributes updated successfully');
          }
        }
      })
      .catch(function(err) {
        if (CONFIG.debug) {
          console.error('Error updating cart attributes:', err);
        }
      });
  }

  // ============================================================================
  // INITIALIZATION
  // ============================================================================

  function init() {
    captureAttributionData();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateShopifyCart);
    } else {
      updateShopifyCart();
    }

    if (CONFIG.debug) {
      console.log('Attribution tracker initialized');
    }
  }

  init();

})();
